import { unwrapNodes } from "@/helpers/graphql";

export function getStyleWithProductsFromMetafield(product) {
  return unwrapNodes(product?.styleWith?.references?.edges) || [];
}

export function toProductGid(id) {
  const idString = String(id).trim();

  if (idString.startsWith("gid://")) {
    return idString;
  }

  return `gid://shopify/Product/${idString}`;
}

export function getStyleWithPairingsFromMetafield(
  product,
  { currentProductId = null } = {}
) {
  const metafieldProducts = getStyleWithProductsFromMetafield(product);

  return metafieldProducts.reduce((pairings, metafieldProduct, index) => {
    if (!metafieldProduct?.id) {
      return pairings;
    }

    if (currentProductId && metafieldProduct.id === currentProductId) {
      return pairings;
    }

    pairings.push({
      id: metafieldProduct.id.split("/").pop(),
      order: index,
      product: metafieldProduct,
    });

    return pairings;
  }, []);
}
